import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import downloadbuttonres1 from "../assets/images/download_button.png";
import downloadbuttonres2 from "../assets/images/download_button2.png";
import Vectornew from "../assets/images/Vector-new.png";
import backgroundrestsec from "../assets/images/bg-app.png";
import module from "../assets/images/moudle_res.png";
import GroupsIcon from '@mui/icons-material/Groups';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import carefor1 from "../assets/images/carefor-1.png";
import carefor2 from "../assets/images/carefor-2.png";
import carefor3 from "../assets/images/carefor-3.png";
import carefor4 from "../assets/images/carefor-4.png";
import carefor5 from "../assets/images/carefor-5.png";
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import doctorRegister from "../assets/images/doctorRegister.jpg";
import caregiverRegister from "../assets/images/caregiverRegister.jpg";

import "./Registration.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import nurgincareimg1 from "../assets/images/nurgincare_img_1.png";

export default function Registration() {
  return (
    <>
      <Header />

      <div
        className="registration_outer"
        style={{ backgroundImage: `url(${backgroundrestsec})` }}
      >
        <div
          className="for_vector_back"
          style={{ backgroundImage: `url(${Vectornew})` }}
        ></div>
        <div className="container-fluid">
          <div className="registration_inner">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <div className="rest_text_sec">
                  <span>Download the Let's Care App</span>
                  <h1>
                    Trusted by Healthcare Professionals for Reliable Career Opportunities. 
                  </h1>
                  <p>
                   Join Let’s Care and create your professional profile as a doctor or caregiver. Showcase your skills, experience, and healthcare services, connect with new opportunities, manage your professional presence, and grow your career through a trusted healthcare partner platform.
                  </p>
                  <div className="downd_btnss">
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres1} alt="downloadbutton-1" />
                    </Link>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres2} alt="downloadbutton-2" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12 ">
                <div className="rest_img_sec">
                  <img src={module} alt="module" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="registration-process-outer">
        <div className="container">
          <div className="registeration-heading">
            <h2>CareAtHome Partner Registration — Steps</h2>
          </div>
        </div>

        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login / Sign Up</h3>
              <p>
                Create an account with your mobile number and OTP, or log in if
                you're already registered.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Personal Details</h3>
              <p>
                Enter your name, email, phone, date of birth, gender, and
                address.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Primary Service</h3>
              <p>Choose whether you're a Caregiver or a Doctor Consultant.</p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Service Type</h3>
              <p>
                Select your exact role: Nursing Care, Physiotherapist, or
                Bedside Attendant.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Specializations</h3>
              <p>
                Pick the cases you can handle (e.g. ICU-at-Home, Oncology,
                Palliative Care) and whether you take Short Term or Long Term
                cases.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">6.</span>
              <h3>Skills & Category</h3>
              <p>
                Tick your specific clinical skills so we can match you with the
                right patients.
              </p>
            </div>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">7.</span>
              <h3>Availability</h3>
              <p>
                Set your available days and time slots, or toggle
                "Flexible/On-call."
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">8.</span>
              <h3>Qualifications & Documents</h3>
              <p>
                Add your highest qualification and upload required documents
                (ID, registration certificate, experience certificate).
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">9.</span>
              <h3>Review & Submit</h3>
              <p>Check all details and submit for verification.</p>
            </div>
            <span class="step-arrow"></span>
          </div>

          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">10.</span>
              <h3>Registration Successful</h3>
              <p>
                Your profile is reviewed within 24–48 hours; once approved, you
                get dashboard access and start receiving patient requests.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div> */}
      

     <div className="for_care_section">
       <div className="container-fluid">
        <div className="heading_care_for">
             <h2 className="heading-about">Smart and Simple <span> Care Management</span> for Healthcare Professionals </h2>
             <p className="pera-about">Manage your professional profile, showcase your healthcare services, and handle bookings efficiently with Let’s Care’s smart and user-friendly partner platform.</p>
          </div>
         <div className="inner_for_care"> 
            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor1} alt="carefor-1" />
               </div>
               <span>Doctors</span>
               <p>Manage professional profiles, patient consultations, digital prescriptions, and appointment schedules with convenient healthcare management tools.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor2} alt="carefor-1" />
               </div>
               <span>Nurses</span>
               <p>Simplify nursing care management with daily care records, shift scheduling, medication reminders, and seamless communication with doctors.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor3} alt="carefor-1" />
               </div>
               <span>Bedside Attendants</span>
               <p>Provide personalized bedside care with daily patient assistance, activity tracking, care updates, and convenient task management.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor4} alt="carefor-1" />
               </div>
               <span>Physiotherapists</span>
               <p>Manage rehabilitation plans, track patient progress, schedule therapy sessions, and support recovery with organized care management tools.</p>
            </div>

            <div className="main_box_forcare">
               <div className="icon-care">
                 <img src={carefor5} alt="carefor-1" />
               </div>
               <span> Care Managers</span>
               <p>Coordinate healthcare services, manage multiple care activities, organize schedules, and streamline daily operations through one platform.</p>
            </div>
         </div>
       </div>
     </div>


      <div class="registration-process-outer">
        <div class="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img content_nursing_img_second">
                    <img src={caregiverRegister} alt="resistration-img-1" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">Caregiver Services at Home</p>
                  <h2 className="heading-about">
                    Benefits of Joining Let’s Care as a<span>  Caregiver</span>{" "}
                   
                  </h2>
                  <p className="pera-about">
                   Join Let’s Care to create your professional profile, showcase your caregiving skills, connect with potential opportunities, and manage service requests conveniently. Build your professional presence and take the next step in your caregiving career with our partner platform.
                  </p>
                  

                  <div className="icon_and_point_res">
  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <GroupsIcon />
      </div>
      <span className="card_badge">+45% REACH</span>
    </div>
    <span>More Patients</span>
    <p>Increase your visibility and connect with more people looking for qualified doctors and professional caregiving services.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <MoneyOffIcon />
      </div>
      <span className="card_badge">100% EARNINGS</span>
    </div>
    <span>Zero Commission</span>
    <p>Keep 100% of your earnings with zero commission on eligible services and transparent payment tracking.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <CalendarMonthIcon />
      </div>
      <span className="card_badge">REAL-TIME SYNC</span>
    </div>
    <span>Smart & Simple</span>
    <p>Easily manage your professional profile, service requests, appointments, and availability through one convenient platform.</p>
  </div>

  <div className="main_sec_ip">
    <div className="card_header_top">
      <div className="main_sec_ip_icon">
        <TrendingUpIcon />
      </div>
      <span className="card_badge">TOP RATED</span>
    </div>
    <span>Grow Your Practice</span>
    <p>Showcase your qualifications, highlight your healthcare expertise, and build your professional presence with Let’s Care.</p>
  </div>
</div>
                </div>
              </div>
            </div>
          </div>
          <div class="registeration-heading text-center">
            <h2>
              Become a <span>Let’s Care</span> Caregiver Partner in 5 Easy Steps 
            </h2>
            <p>
              Register as a caregiver on the Let’s Care Partner App, showcase your experience, and explore professional growth opportunities.
            </p>
          </div>
        </div>
        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Log In / Register Yourself</h3>
              <p>
                Log in with your registered mobile number and password, or create a new account using your mobile number and OTP verification.
              </p>
            </div>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose Caregiver and select your preferred service, such as nursing care, physiotherapy, or bedside attendant services.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Enter your personal details, contact information, location, education, and caregiving experience to build your professional profile.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3> Service, Fee & Availability</h3>
              <p>
               Select your caregiving service, set your service fees, and choose your available days and time slots before submitting your details.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successful</h3>
              <p>
                Once submitted, your profile will be reviewed for verification. After approval, access your dashboard and start exploring caregiving opportunities through Let’s Care.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <div className="network_section">
        <div className="container-fluid">
          <div className="inner_network_section">
              <div className="heading_care_for">
                <h3 className="heading-about">Become a Healthcare Partner with  <span>Let’s Care</span> </h3>
                <p className="pera-about">Partner with Let’s Care to expand your reach, showcase your services, and grow your healthcare business.</p>
              </div>
              <div className="network_content_sec">
                <div className="row">
                  <div className="col-lg-5 col-md-5 col-12">
                    <div className="business_sec">
                      <span className="b2b">B2B & B2C Opportunities</span>
                      <h3>For Business Providers</h3>
                      <p>Medical Equipment Providers, Diagnostic Labs & Medical Stores</p>
                      <div className="business_box_prt">
                        <div className="business_icon_text">
                          <div className="only_icon_business">
                              <MedicalServicesIcon/>
                          </div>
                          <span>Medical Equipment Providers</span>
                        </div>
                          <div className="business_icon_text">
                          <div className="only_icon_business">
                              <ScienceOutlinedIcon/>
                          </div>
                          <span>Labs & Diagnostic Centers</span>
                        </div>
                          <div className="business_icon_text">
                          <div className="only_icon_business">
                              <StoreOutlinedIcon/>
                          </div>
                          <span>Medical Stores / Pharmacies</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-12">
                    <div className="Partner_sec">
                       <h4>Why Partner As A Business?</h4>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">No Subscription Charges <span>FREE FOR NOW</span></h4>
                         <p>Register your business without subscription fees during the current free period and showcase your healthcare products or services on the platform.</p>
                       </div>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">Showcase with B2B & B2C Pricing</h4>
                         <p>Set separate prices for business buyers and direct customers, making it easier to display your offerings to healthcare partners and individual buyers.</p>
                       </div>
                       <div className="partner_icon-text_prt">
                         <div className="icon_only_partner">
                           <CheckOutlinedIcon/>
                         </div>
                         <h4 className="partner_title">More Visibility. More Business.</h4>
                         <p>Help more potential customers discover your medical equipment, diagnostic services, or pharmacy products through your business listing on Let’s Care.</p>
                       </div>
                        <div className="downd_btnss">
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres1} alt="downloadbutton-1" />
                    </Link>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.letscare"
                      target="_blank"
                    >
                      <img src={downloadbuttonres2} alt="downloadbutton-2" />
                    </Link>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
          </div> 
        </div>
      </div>

      <div class="registration-process-outer registration-process-outer-2">
        <div class="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">Doctor Consultant</p>
                  <h4 className="heading-about">
                    Become a <span>Doctor Consultant</span> Partner with Let’s Care 
                  </h4>
                  <p className="pera-about">
                    Join Let’s Care to showcase your medical qualifications, specialisations, and professional experience through a dedicated profile. Offer doctor consultation services through video calls, clinic visits, or home visits, giving you the flexibility to choose how you provide consultations.
                  </p>
                  <p className="pera-about">
                    Manage your consultation fees, working days, and available time slots conveniently through the Let’s Care Partner App. Strengthen your online presence, showcase your expertise, and explore opportunities to expand your medical practice through a platform designed for healthcare professionals.
                  </p>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={doctorRegister} alt="resistration-img-1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="registeration-heading text-center">
            <h4>
              {" "}
              Join Our <span> Doctor Consultant</span> Network in 5 Simple Steps
            </h4>
            <p>
              Register with Let’s Care in five simple steps to create your professional profile and start offering doctor consultation services.
            </p>
          </div>
        </div>
        <div class="partner-process">
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">1.</span>
              <h3>Login In / Register Yourself</h3>
              <p>
                Log in using your registered mobile number and password, or create a new account with your mobile number and OTP verification.
              </p>
            </div>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">2.</span>
              <h3>Select Your Primary Service</h3>
              <p>
                Choose a doctor consultant and select your preferred consultation mode: online video call, at the clinic, or at home.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">3.</span>
              <h3>Tell Us About Yourself</h3>
              <p>
                Enter your name, contact details, location, educational qualifications, and professional experience to complete your doctor profile.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">4.</span>
              <h3>Choose Your Medical Expertise</h3>
              <p>
                Select your medical specialization, consultation mode, and consultation fees. Set your available days and time slots, then submit your details.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
          <div class="partner-step">
            <div class="step-content">
              <span class="step-number">5.</span>
              <h3>Registration Successful</h3>
              <p>
                Your profile will be reviewed for verification. Once approved, you can access your dashboard and manage your doctor consultation services through Let’s Care.
              </p>
            </div>
            <span class="step-arrow"></span>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
